import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-destination',
    templateUrl: './destination.component.html',
    styleUrls: ['./destination.component.scss'],
    standalone: false
})
export class DestinationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
